import type {
  ExamSectionDraft,
  ExamSectionId,
  SectionSnapshot,
  TextSectionDraft,
  TextSectionId,
} from './hireHealthSurveyTypes';

function formatDisplayDate(iso: string): string {
  const m = iso.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!m) return iso;
  return `${m[1]}/${m[2]}/${m[3]}`;
}

function yesNo(t: (k: string) => string, v: string): string {
  if (v === 'yes') return t('submitDocuments.hireHealthSurvey.yes');
  if (v === 'no') return t('submitDocuments.hireHealthSurvey.no');
  return '—';
}

function fitLabel(t: (k: string) => string, fit: string): string {
  if (fit === 'fit') return t('submitDocuments.hireHealthSurvey.fit');
  if (fit === 'not_fit') return t('submitDocuments.hireHealthSurvey.notFit');
  return '—';
}

function gateQuestionKey(sectionId: ExamSectionId | TextSectionId): string {
  return `submitDocuments.hireHealthSurvey.gate.${sectionId}`;
}

export function buildExamSectionSummary(
  sectionId: ExamSectionId,
  d: ExamSectionDraft,
  t: (k: string) => string
): string {
  const lines: string[] = [];
  lines.push(t(gateQuestionKey(sectionId)));
  if (d.hadExam === 'no') {
    lines.push(t('submitDocuments.hireHealthSurvey.no'));
    return lines.join('\n');
  }
  lines.push(t('submitDocuments.hireHealthSurvey.yes'));
  if (d.examDate) {
    lines.push(`${t('submitDocuments.hireHealthSurvey.summary.date')}: ${formatDisplayDate(d.examDate)}`);
  }
  if (d.hospital.trim()) {
    lines.push(`${t('submitDocuments.hireHealthSurvey.summary.hospital')}: ${d.hospital.trim()}`);
  }
  if (d.fit) {
    lines.push(`${t('submitDocuments.hireHealthSurvey.summary.doctorsJudgement')}: ${fitLabel(t, d.fit)}`);
  }
  return lines.join('\n');
}

export function buildTextSectionSummary(
  sectionId: TextSectionId,
  d: TextSectionDraft,
  t: (k: string) => string
): string {
  const lines: string[] = [];
  lines.push(t(gateQuestionKey(sectionId)));
  if (d.hadIssue === 'no') {
    lines.push(
      sectionId === 'symptoms'
        ? t('submitDocuments.hireHealthSurvey.noSymptoms')
        : t('submitDocuments.hireHealthSurvey.no')
    );
    return lines.join('\n');
  }
  lines.push(t('submitDocuments.hireHealthSurvey.yes'));
  if (d.detail.trim()) {
    lines.push(d.detail.trim());
  }
  return lines.join('\n');
}

export function buildSectionSummary(snapshot: SectionSnapshot, t: (k: string) => string): string {
  if (snapshot.kind === 'exam') {
    return buildExamSectionSummary(snapshot.sectionId, snapshot.data, t);
  }
  return buildTextSectionSummary(snapshot.sectionId, snapshot.data, t);
}
